 <!-- 搜索 -->
<template>
  <div class="search-input">
    <!-- 按回车键有一个进入搜索内容页面 -->
    <input
      id="inputpanel"
      type="text"
      v-model="keyword"
      @keydown.enter="search()"
      :placeholder="constant.searchPlaceHolder"
      @input="searchInput($event)"
    />
    <!-- 这是一个小叉叉，点击它可清除输入框内容 -->
    <span class="search-reset" @click="clearInput()" v-show="showclear"
      >&times;</span
    >
    <el-button class="search-btn" @click="search()">
      <img :style="styleObject" src="img/search.png" />
    </el-button>
  </div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  data: function () {
    return {
      keyword: "", //v-model绑定的输入框的value
      constant: this.$store.state.malMainPageConfig.constant,
      showclear: false,
    };
  },
  computed: {
    styleObject: function () {
      return {
        height: "20px",
        "margin-right": "8px ",
      };
    },
  },
  methods: {
    searchInput: function () {
      if (this.keyword.length > 0) {
        this.showclear = true;
      } else {
        this.showclear = false;
      }
    },
    search: function () {
      //打开对应的搜索界面
      if (this.keyword.length > 0) {
        if (this.keyword.length > 100) {
          this.keyword = this.keyword.substring(0, 100);
        }
        let word = encodeURIComponent(this.keyword);
      
        let url =
          axios.defaults.baseURL +
          "/index.html#/dform?&formId=" + this.$store.state.malMainPageConfig.searchFormId + "&searchText=" +
          word +
          "&searchFields=['goods','supplier.name']";
        window.open(url, "_blank");
      }
    },
    clearInput: function () {
      this.keyword = "";
      this.showclear = false;
    },
  },
};
</script>

<style type="text/css">
.search-input {
  height: 40px;
  width: 518px;
  position: relative;
  border-radius: 25px;
}
.search-input input {
  border: 1px solid #2386ee;
  box-sizing: border-box;
  width: 434px;
  height: 40px;
  font-size: 18px;
  float: left;
  padding-left: 10px;
  padding-right: 32px;
  overflow: hidden;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  outline: none;
}
.search-btn {
  height: 40px;
  width: 84px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  float: left;
  border-width: 0px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-image: linear-gradient(158deg, #2386ee 0%, #2386ee 100%);
  cursor: pointer;
  margin-left: -1px;
}
.search-select {
  position: absolute;
  top: 48px;
  width: 518px;
  box-sizing: border-box;
  z-index: 999;
}
.search-select li {
  border: 1px solid #d4d4d4;
  border-top: none;
  border-bottom: none;
  background-color: #fff;
  width: 100%;
}
.search-select-option {
  box-sizing: border-box;
  padding: 7px 10px;
}
.selectback {
  background-color: #eee !important;
  cursor: pointer;
}
input::-ms-clear {
  display: none;
}
.search-reset {
  width: 21px;
  height: 21px;
  position: absolute;
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  right: 95px;
  top: 12px;
}
.itemfade-enter,
.itemfade-leave-active {
  opacity: 0;
}
.itemfade-leave-active {
  position: absolute;
}
.selectback {
  background-color: #eee !important;
  cursor: pointer;
}
.search-select ul {
  text-align: left;
  list-style-type: none;
  margin-top: 0px;
  margin-left: -20px;
}

#inputpanel::-webkit-input-placeholder {
  opacity: 0.6;
  font-size: 16px;
}
#inputpanel::-moz-placeholder {
  opacity: 0.6;
  font-size: 16px;
}
#inputpanel::-ms-input-placeholder {
  opacity: 0.6;
  font-size: 16px;
}
</style>